import { Stack } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import { LoadingButton } from '@altimateai/lego'
import { Link } from "react-router-dom";

interface ProjectActionButtonsProps {
  onBack: () => void;
  onSave: () => void;
  canSave: boolean;
  isSubmitting: boolean;
}

export const ProjectActionButtons = ({
  onBack,
  onSave,
  canSave,
  isSubmitting,
}: ProjectActionButtonsProps) => {
  return (
    <Stack direction="row" justify="between" className="al-items-center al-mt-6">
      <Button variant={"outline"} asChild>
        <Link to="/settings/datastores">Cancel</Link>
      </Button>
      <Stack direction="row" gap="md">
        <Button variant="secondary" onClick={onBack}>
          Back
        </Button>
        <LoadingButton onClick={onSave} disabled={!canSave} loading={isSubmitting}>
          Finish
        </LoadingButton>
      </Stack>
    </Stack>
  );
};
